<template>
    <div class="personalCenter">
        <div class="personal_img">
            <img src="../../assets/images/personalCenter/center_02.png" alt="">
            <div class="photo">
                <img :src="user.head_pic?user.head_pic.replace('/public',weburl+'/public'):this.dePhotoImg" alt="">
            </div>
        </div>
        <p>{{user.mobile}}
            <i class="fa  fa-pencil-square-o " @click="goPersonalData()"></i></p>
        <ul class="center_icons">
            <li @click="goOrder()">
                <div class="icons_img"><img src="../../assets/images/personalCenter/1.png" alt=""></div>
                <span>{{$t("my_order")}}</span>
            </li>
            <li @click="goDiscount()">
                <div class="icons_img"><img src="../../assets/images/personalCenter/2.png" alt=""></div>
                <span>{{$t('card_bag')}}</span>
            </li>
           <li @click="goMyJoin()">
                <div class="icons_img"><img src="../../assets/images/personalCenter/3.png" alt=""></div>
                <span>{{$t('join')}}</span>
            </li>
            <!-- <li>
                <div class="icons_img"><img src="../../assets/images/personalCenter/4.png" alt=""></div>
                <span>账户安全</span>
            </li> -->
        </ul>
    </div>
</template>
<script>
import dePhoto from "../../assets/images/personalCenter/photo.png";
export default {
  name: "personalCenter",
  data() {
    return {
      dePhotoImg: dePhoto,
      user: {}
    };
  },
  created() {
    this.$store.commit("set_current", "-1");
    this.user = JSON.parse(localStorage.getItem("userInfo"));
    this.$store.commit("set_title", "personal");
  },
  computed: {
    weburl: function() {
      return this.$store.state.weburl;
    }
  },
  methods: {
    goOrder: function() {
      this.$router.push({ path: `/myOrder` });
    },
    goMyJoin: function() {
      this.$router.push({ path: `/myJoin` });
    },
    goDiscount: function() {
      this.$router.push({ path: `/discount` });
    },
    goPersonalData: function() {
      this.$router.push({ path: `/personalData` });
    }
  }
};
</script>

<style scoped lang="less">
@import "../../assets/less/common.less";
.personalCenter {
  .media;
}
.personal_img {
  width: 100%;
  height: 186px;
  position: relative;
  margin-bottom: 75px;
  & > img {
    width: 120%;
    margin-left: -36px;
    .border-radius(0 0 200px 200px);
  }
  .photo {
    position: absolute;
    left: 50%;
    width: 80px;
    height: 80px;
    bottom: -100px;
    .box-sizing;
    .border-radius(50%);
    /*   border: 2px solid @brick_red;*/
    transform: translate(-50%, -50%);
    img {
      .img;
      .border-radius(50%);
    }
  }
}

p {
  font-size: @font + 0.1;
  text-align: center;
  margin-bottom: 40px;

  i {
    color: @brick_red;
    margin-left: 10px;
  }
}

.center_icons {
  display: flex;
  flex-wrap: wrap;
  width: 78%;
  margin: auto;
  li {
    width: 84px;
    height: 100px;
    margin-right: 20px;
    margin-bottom: 20px;
    text-align: center;
    cursor: pointer;
    &:nth-child(3) {
      margin-right: 0;
    }
    .icons_img {
      width: 50%;
      margin: auto;
      img {
        .img;
      }
    }
    span {
      line-height: 30px;
    }
  }
}
</style>
